import {IssueGroupingKey} from '@domain/stoppages'
import {MenuItem, TextField} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

type GroupByDropDownProps = {
  value: IssueGroupingKey
  onChange: (value: IssueGroupingKey) => void
  'data-test-id': string
}

export const GroupByDropDown: React.FC<GroupByDropDownProps> = ({
  value,
  onChange,
  'data-test-id': dataTestId
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <TextField
      variant="outlined"
      fullWidth
      id="group-by-drop-down"
      name="groupBy"
      select
      label={t('actions.groupBy')}
      value={value}
      onChange={(e) => {
        onChange(e.target.value as IssueGroupingKey)
      }}
      data-test-id={`${dataTestId}-select`}
    >
      {Object.values(IssueGroupingKey).map((key) => (
        <MenuItem key={key} value={key} data-test-id={`${dataTestId}-${key}`}>
          {t(
            `actions.${key === IssueGroupingKey.STOPPED_MAIN_EQUIPMENT ? 'stoppedMainEquipment' : key}`
          )}
        </MenuItem>
      ))}
    </TextField>
  )
}
